<template>
  <v-card align="center" justify="center" light min-width="27vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <v-textarea :placeholder="$t('placeholderPost')" v-model="post" auto-grow rows="4" counter="700" :rules="postRules" outlined/>
      <v-select :items="channels" prepend-icon="fa-layer-group" v-model="channel" item-text="name" item-value="id" :label="$t('labelChannel')" outlined/>
      <v-btn @click="addPost">{{ $t('btnPublish') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "AddPost",
  data() {
    return {
      post: '',
      channels: [],
      channel: this.$store.state.currentClubChannel.id,
      postRules: [
        p => !!p || this.$t('errors.empty'),
        p => (p && p.length <= 700) || this.$t('errors.maxChars'),
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.channels = [{ id: -1, name: 'GENERAL' }];
      this.$store.state.clubChannelsContributedByMe.forEach((channelContribution) => {
        this.channels.push(channelContribution.clubChannel);
      });
      this.channels.push.apply(this.channels, this.$store.state.clubPublicChannels);
    },
    ...mapMutations(['setClubPosts']),
    addPost() {
      let post = {
        clubMember: { id: this.$store.state.clubMember.id },
        post: this.post,
        date: new Date(),
      };
      if(this.channel !== -1)
        post.clubChannel = { id: this.channel };

      Repository.createClubPost(post).then((response) => {
        if(response.status < 400) {
          alert(this.$t('alert'));
          Repository.getAllClubPostsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((secondResponse) => {
            if(secondResponse.status < 400)
              this.setClubPosts(secondResponse.data);
          });
          this.close();
        }
      });
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Publish a Post",
    "placeholderPost": "Write your message...",
    "labelChannel": "Channel",
    "errors": {
      "empty": "Post could not be empty",
      "maxChars": "Max 700 characters"
    },
    "alert": "Post created successfully!",
    "btnPublish": "Publish Now"
  },
  "es": {
    "title": "Crear Publicación",
    "placeholderPost": "Escribe tu mensaje...",
    "labelChannel": "Canal",
    "errors": {
      "empty": "Publicación no puede ser vacía",
      "maxChars": "Máximo 700 caracteres"
    },
    "alert": "¡Publicación creada satisfactoriamente!",
    "btnPublish": "Publicar Ahora"
  }
}
</i18n>

<style scoped>

</style>
